import { render, staticRenderFns } from "./ModalTabs.vue?vue&type=template&id=07e8b72e"
import script from "./ModalTabs.vue?vue&type=script&lang=ts"
export * from "./ModalTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07e8b72e')) {
      api.createRecord('07e8b72e', component.options)
    } else {
      api.reload('07e8b72e', component.options)
    }
    module.hot.accept("./ModalTabs.vue?vue&type=template&id=07e8b72e", function () {
      api.rerender('07e8b72e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/ModalTabs.vue"
export default component.exports